export const createSearchPattern = (keyword) => {
  const keywords = String(keyword)
    .toLocaleLowerCase()
    .trim()
    .split(/[-_\s\\|!@#$%^&*()]+/i)
  return new RegExp(`(${keywords.join('.*')})+`, 'i')
}
